import { render, staticRenderFns } from "./renewal.vue?vue&type=template&id=22e8bc2e&scoped=true"
import script from "./renewal.vue?vue&type=script&lang=js"
export * from "./renewal.vue?vue&type=script&lang=js"
import style0 from "./renewal.vue?vue&type=style&index=0&id=22e8bc2e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22e8bc2e",
  null
  
)

export default component.exports